import { isNullOrEmpty } from './utils';

const passEvent = eventInfo => {
  try {
    if (window.environment.appMode !== 'DEV') {
      // eslint-disable-next-line no-undef
      gtag('event', 'click', {
        event_category: eventInfo.eventCategory,
        event_action: eventInfo.eventAction,
        event_label: eventInfo.eventLabel
      });
    }
  } catch (err) {
    console.error(`Exception while pushing to analytics ${err}`);
  }
};

const mixpanelPassEvent = (action, data) => {
  // eslint-disable-next-line no-undef
  if (window.mixpanel) window.mixpanel.track(action, data);
};

const mixpanelIdentify = user => {
  if (user && user.email && user.semanticName && window.mixpanel) {
    window.mixpanel.people.set({
      $email: user.email, // only reserved properties need the $
      USER_ID: user.semanticName
    });

    window.mixpanel.identify(user.semanticName);
  }
};

const pushEventsToAnalytics = (category, action, label) => {
  try {
    if (
      isNullOrEmpty(category) &&
      isNullOrEmpty(action) &&
      isNullOrEmpty(label)
    ) {
      passEvent({
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      });
    }
    if (category !== 'AdaptiveU')
      passEvent({
        hitType: 'event',
        eventCategory: 'AdaptiveU',
        eventAction: action,
        eventLabel: label
      });
  } catch (err) {
    console.error(`error while pushing events to mixpanel:: ${err.message}`);
  }
};

export default passEvent;
export { mixpanelPassEvent, mixpanelIdentify, pushEventsToAnalytics };
